import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/main.scss';
import VisitRequestForm from './components/forms/VisitRequestForm';
import WWOOFerVisitRequestForm from './components/forms/WWOOFerVisitRequestForm';
import BookingDashboard from './components/booking/BookingDashboard';
import UserAvailabilityCalendar from './components/availability/UserAvailabilityCalendar';

// Wait for React to be available (keeping compatibility with WordPress setup)
function waitForReact(callback) {
  if (typeof React !== 'undefined' && typeof createRoot !== 'undefined') {
    callback();
  } else {
    setTimeout(() => waitForReact(callback), 100);
  }
}

waitForReact(function () {
  // Initialize components when DOM is ready
  document.addEventListener('DOMContentLoaded', function () {
    // Initialize Visit Request Form (Host-initiated)
    const visitRequestForm = document.getElementById('wwoof-visit-request-form');
    if (visitRequestForm) {
      const wwooferId = parseInt(visitRequestForm.dataset.wwooferId);
      const hostId = parseInt(visitRequestForm.dataset.hostId);
      const threadId = parseInt(visitRequestForm.dataset.threadId);

      const root = createRoot(visitRequestForm);
      root.render(
        <VisitRequestForm
          wwooferId={wwooferId}
          hostId={hostId}
          threadId={threadId}
        />
      );
    }

    // Initialize WWOOFer Visit Request Form (WWOOFer-initiated)
    const wwooferVisitRequestForm = document.getElementById('wwoof-wwoofer-visit-request-form');
    if (wwooferVisitRequestForm) {
      const hostId = parseInt(wwooferVisitRequestForm.dataset.hostId);
      const wwooferId = parseInt(wwooferVisitRequestForm.dataset.wwooferId);
      const threadId = parseInt(wwooferVisitRequestForm.dataset.threadId);

      const root = createRoot(wwooferVisitRequestForm);
      root.render(
        <WWOOFerVisitRequestForm
          hostId={hostId}
          wwooferId={wwooferId}
          threadId={threadId}
        />
      );
    }

    // Initialize Booking Dashboard
    const bookingDashboard = document.getElementById('wwoof-booking-dashboard');
    if (bookingDashboard) {
      const userId = parseInt(bookingDashboard.dataset.userId);
      const view = bookingDashboard.dataset.view;

      const root = createRoot(bookingDashboard);
      root.render(
        <BookingDashboard
          userId={userId}
          view={view}
        />
      );
    }

    // Initialize User Availability Calendar (read-only profile shortcode)
    const availabilityCalendar = document.getElementById('wwoof-user-availability-calendar');
    if (availabilityCalendar) {
      const userId = parseInt(availabilityCalendar.dataset.userId);
      let bookingDates = [];
      if (availabilityCalendar.dataset.bookingDates) {
        try {
          bookingDates = JSON.parse(availabilityCalendar.dataset.bookingDates);
        } catch (e) {
          bookingDates = [];
        }
      }
      const root = createRoot(availabilityCalendar);
      root.render(<UserAvailabilityCalendar userId={userId} bookingDates={bookingDates} />);
    }
  });
});
